// components/Footer.js
import React from "react";

const Footer = () => {
  return (
    <footer
      style={{
        background: "#1a1a2e",
        color: "white",
        padding: "60px 5% 40px",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: "40px",
        }}
      >
        <div style={{ flex: "1 1 300px" }}>
          <div
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              marginBottom: "20px",
            }}
          >
            Arcadia
          </div>
          <p
            style={{
              fontSize: "16px",
              lineHeight: 1.6,
              color: "rgba(255,255,255,0.7)",
              marginBottom: "20px",
            }}
          >
            A modern gaming platform with a focus on direct player connections
            and zero server infrastructure.
          </p>
          <div
            style={{
              display: "flex",
              gap: "15px",
            }}
          >
            {/* Social media icons */}
            {["facebook", "twitter", "instagram", "github"].map((social) => (
              <a
                key={social}
                href="#"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.1)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  transition: "background 0.2s",
                }}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
            ))}
          </div>
        </div>

        <div style={{ flex: "1 1 150px" }}>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "20px",
              color: "#61dafb",
            }}
          >
            Platform
          </h3>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
            }}
          >
            {["Games", "How It Works", "Technology", "Support"].map((item) => (
              <li key={item} style={{ marginBottom: "12px" }}>
                <a
                  href="#"
                  style={{
                    color: "rgba(255,255,255,0.7)",
                    textDecoration: "none",
                    transition: "color 0.2s",
                    fontSize: "16px",
                  }}
                >
                  {item}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div style={{ flex: "1 1 150px" }}>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "20px",
              color: "#61dafb",
            }}
          >
            Games
          </h3>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
            }}
          >
            {[
              "Single Player",
              "Multiplayer",
              "Puzzles",
              "Action",
              "Strategy",
            ].map((item) => (
              <li key={item} style={{ marginBottom: "12px" }}>
                <a
                  href="#"
                  style={{
                    color: "rgba(255,255,255,0.7)",
                    textDecoration: "none",
                    transition: "color 0.2s",
                    fontSize: "16px",
                  }}
                >
                  {item}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div style={{ flex: "1 1 300px" }}>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "20px",
              color: "#61dafb",
            }}
          >
            Stay Updated
          </h3>
          <p
            style={{
              fontSize: "16px",
              lineHeight: 1.6,
              color: "rgba(255,255,255,0.7)",
              marginBottom: "20px",
            }}
          >
            Subscribe to our newsletter for the latest games and features.
          </p>
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            <input
              type="email"
              placeholder="Enter your email"
              style={{
                flex: 1,
                padding: "12px 15px",
                borderRadius: "8px",
                border: "none",
                fontSize: "16px",
                background: "rgba(255,255,255,0.1)",
                color: "white",
                outline: "none",
              }}
            />
            <button
              style={{
                background: "#61dafb",
                color: "#1a1a2e",
                border: "none",
                padding: "12px 20px",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>

      <div
        style={{
          borderTop: "1px solid rgba(255,255,255,0.1)",
          marginTop: "40px",
          paddingTop: "20px",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        <p style={{ fontSize: "14px", color: "rgba(255,255,255,0.6)" }}>
          © 2025 Arcadia. All rights reserved.
        </p>
        <div
          style={{
            display: "flex",
            gap: "20px",
          }}
        >
          {["Privacy Policy", "Terms of Service", "Cookie Policy"].map(
            (item) => (
              <a
                key={item}
                href="#"
                style={{
                  color: "rgba(255,255,255,0.6)",
                  textDecoration: "none",
                  fontSize: "14px",
                  transition: "color 0.2s",
                }}
              >
                {item}
              </a>
            )
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
